import _ from 'lodash'

import { OrderCommits } from '@/data/OrderCommits.ts'
import { generateSignalDataAccess } from '@/react/utils/generateSignalDataAccess'

export const [orderCommits0, makeOrderCommitsAvailable] = generateSignalDataAccess(OrderCommits)

Object.assign(window, { orderCommits0 })
